// eslint-disable-next-line max-classes-per-file
import { IdmsType } from 'app/viewmodels/analysis/inspection-reports/idms-type';
import { CONFIG } from '../../../core/config';
import { InspectionReportBase } from '../../analysis/inspection-reports/inspection-report-base';
import { ViewModel } from '../../view-model';
import { ThicknessLocationReading } from './thickness-location-reading';

export class ThicknessReport extends InspectionReportBase implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Thickness Report';
  readonly apiRoute: string = CONFIG.apiRoutes.thicknessReports;

  reportNumber: string;
  thicknessReportType: ThicknessInspectionReportType;
  thicknessLocationReadings: ThicknessLocationReading[] = [];
  evaluationsDisplayConfig: ThicknessReportEvaluationsDisplayConfig = new ThicknessReportEvaluationsDisplayConfig();
  idmsType: IdmsType = IdmsType.ThicknessReport;
  company: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    super.loadFromJson(data);

    this.reportNumber = data.reportNumber;
    this.company = data.company;
    this.thicknessReportType = data.thicknessReportType;

    if (data.thicknessLocationReadings) {
      data.thicknessLocationReadings.forEach(reading => {
        const newReading = new ThicknessLocationReading();
        newReading.loadFromJson(reading);
        this.thicknessLocationReadings.push(newReading);
      });
    }

    if (data.evaluationsDisplayConfig) {
      this.evaluationsDisplayConfig = new ThicknessReportEvaluationsDisplayConfig();
      this.evaluationsDisplayConfig.loadFromJson(data.evaluationsDisplayConfig);
    }
  }
}

export class ThicknessReportEvaluationsDisplayConfig {
  thicknessReportEvaluationsDisplayConfigId: string;

  showShortTermCorrosion: boolean = true;
  showLongTermCorrosion: boolean = true;
  showMinimumThickness: boolean = true;
  showCurrentReading: boolean = true;
  excludeGrowth: boolean;
  showAvgShortTermCorrosion: boolean = true;
  showAvgLongTermCorrosion: boolean = true;

  selectedThicknessLocations: ThicknessReportEvaluationsLocationSelection[] = [];

  thicknessReportId: string;

  loadFromJson(data) {
    this.thicknessReportEvaluationsDisplayConfigId = data.thicknessReportEvaluationsDisplayConfigId;

    this.showShortTermCorrosion = data.showShortTermCorrosion;
    this.showLongTermCorrosion = data.showLongTermCorrosion;
    this.showMinimumThickness = data.showMinimumThickness;
    this.showCurrentReading = data.showCurrentReading;
    this.excludeGrowth = data.excludeGrowth;

    if (data.selectedThicknessLocations) {
      data.selectedThicknessLocations.forEach(locationSelection => {
        const newLocationSelection = new ThicknessReportEvaluationsLocationSelection();
        newLocationSelection.loadFromJson(locationSelection);
        this.selectedThicknessLocations.push(newLocationSelection);
      });
    }

    this.thicknessReportId = data.thicknessReportId;
  }
}

export class ThicknessReportEvaluationsLocationSelection {
  thicknessReportEvaluationsDisplayConfigId: string;
  thicknessLocationId: string;

  loadFromJson(data) {
    this.thicknessReportEvaluationsDisplayConfigId = data.thicknessReportEvaluationsDisplayConfigId;
    this.thicknessLocationId = data.thicknessLocationId;
  }
}

export enum ThicknessInspectionReportType {
  EddyCurrent = 1,
  Iris = 2,
  Rt = 3,
  Ut = 4,
}
